import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "store";
import { updateUser } from "api/userService";
import { setUser } from "store/slices/userSlice";
import { UserManualManager } from "./UserManualManager";
import UserManualModal, { getManualVersion, getStartPageForUser, getPageByVersion } from "./UserManualModal";

const UserManualPopup: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [initialSlide, setInitialSlide] = useState(0);
  const [shouldUpdateVersion, setShouldUpdateVersion] = useState(false);
  const { user } = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    const handleStateChange = (state: any) => {
      setIsOpen(state.visible);
      if (state.visible && state.options) {
        // 우선순위: version > baseVersion > 0
        let startPage = 0;
        if (state.options.version) {
          // version이 있으면 해당 섹션의 첫 페이지로 점프
          startPage = getPageByVersion(state.options.version);
        } else if (state.options.baseVersion) {
          // version이 없고 baseVersion만 있으면 기존 로직 (날짜 비교)
          startPage = getStartPageForUser(state.options.baseVersion);
        }
        setInitialSlide(startPage);
        setShouldUpdateVersion(state.options.shouldUpdateVersion || false);
      }
    };

    UserManualManager.addListener(handleStateChange);
    return () => UserManualManager.removeListener(handleStateChange);
  }, []);

  // 팝업 열릴 때 버전 업데이트 (shouldUpdateVersion === true)
  useEffect(() => {
    if (isOpen && shouldUpdateVersion && user) {
      const currentVersion = getManualVersion();
      updateUser(user.id, { manualVersion: currentVersion })
        .then(() => {
          dispatch(setUser({ ...user, manualVersion: currentVersion }));
        })
        .catch((error) => {
          console.error("manualVersion 업데이트 실패:", error);
        });
    }
  }, [isOpen, shouldUpdateVersion, user, dispatch]);

  const handleClose = () => {
    UserManualManager.hide();
  };

  return (
    <UserManualModal
      isOpen={isOpen}
      onClose={handleClose}
      initialSlide={initialSlide}
    />
  );
};

export default UserManualPopup;
